var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "ic100/well done",
    clipPath: "url(#clip0_2589_9846)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Exclude",
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.0732 44.9042C79.264 47.1633 77.5873 49.1494 75.3282 49.3401C73.0691 49.5309 71.0831 47.8542 70.8923 45.5951C70.7015 43.336 72.3782 41.35 74.6373 41.1592C76.8964 40.9684 78.8825 42.6451 79.0732 44.9042Z",
    fill: "#0075F8"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 1704",
    d: "M46.8261 52.0007L45 38.4674H55.9565V25.9007L66 23.0007",
    stroke: "#0075F8",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 12449",
    d: "M85.3109 32.9969C83.2427 32.8495 81.6843 31.0554 81.8278 28.987L82.8842 13.7576C83.028 11.6835 84.8281 10.1199 86.902 10.2677C88.9702 10.4151 90.5285 12.2091 90.385 14.2776L89.3287 29.5069C89.1848 31.5811 87.3847 33.1446 85.3109 32.9969Z",
    fill: "#0075F8"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 8.57734,
    y: 22.2146,
    width: 70.277,
    height: 70.6869
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.1px)",
      clipPath: "url(#bgblur_1_2589_9846_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Polygon 9",
    "data-figma-bg-blur-radius": 2.2,
    d: "M26.1807 26.7156C26.7596 24.4393 29.5856 23.6433 31.2675 25.2829L75.7313 68.6278C77.4132 70.2674 76.6895 73.1127 74.4287 73.7495L14.6589 90.5838C12.3981 91.2206 10.2958 89.1712 10.8747 86.8949L26.1807 26.7156Z",
    fill: "#D2E7FF",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_2589_9846_clip_path",
    transform: "translate(-8.57734 -22.2146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.1807 26.7156C26.7596 24.4393 29.5856 23.6433 31.2675 25.2829L75.7313 68.6278C77.4132 70.2674 76.6895 73.1127 74.4287 73.7495L14.6589 90.5838C12.3981 91.2206 10.2958 89.1712 10.8747 86.8949L26.1807 26.7156Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2589_9846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.387d1f7d8fa54d103cbee684cab0c2e4.svg";
export { ForwardRef as ReactComponent };